// gamelist2 页面私有文案：zh 为完整基准，en 逐 key 对齐
// 横竖版徽标与"查看详情"走 commonDict.game，本字典只收页面私有文案
export interface Gamelist2Dict {
    hero: {
        badge: string
        /** 大标题前半段（白色），与 titleB 拼接展示 */
        titleA: string
        /** 大标题后半段（渐变流光） */
        titleB: string
        subtitle: string
    }
    tabs: {
        /** "所有游戏" TAB 显示名（筛选匹配仍用中文 key ALL_GAME_KEY） */
        all: string
        /** "推荐" TAB 显示名（后台对单个游戏设置推荐标记） */
        recommended: string
    }
    /** 顶部搜索框（客户端模糊过滤：名称/一句话描述/简介，大小写不敏感） */
    search: {
        placeholder: string
        /** 清除按钮 aria-label */
        clear: string
        /** 搜索无结果空态标题，含 {q} 占位符 */
        emptyTitle: string
        emptyHint: string
    }
    /** 特性筛选（第二维度）：chips 行前置 label；chips 内容来自游戏标签，不入字典 */
    features: {
        label: string
    }
    /** 榜单区标题（推荐/新品/热门横滑卡条） */
    boards: {
        recommended: string
    }
    empty: {
        /** 含 {cat} 占位符，渲染时替换为当前分类显示名 */
        title: string
        hint: string
    }
    /** 海外游戏大陆遮罩文案 */
    overseaBlocked: string
}

export const gamelist2Dict: { zh: Gamelist2Dict; en: Gamelist2Dict } = {
    zh: {
        hero: {
            badge: 'Game Library',
            titleA: '游戏展示',
            titleB: '中心',
            subtitle: '全品类游戏内容一站尽览，多端多语言',
        },
        tabs: { all: '所有游戏', recommended: '推荐' },
        search: {
            placeholder: '搜索游戏名称、描述或简介…',
            clear: '清除搜索',
            emptyTitle: '没有找到与「{q}」匹配的游戏',
            emptyHint: '换个关键词试试，或切换到其他分类看看',
        },
        features: { label: '特性' },
        boards: { recommended: '★ 推荐榜' },
        empty: {
            title: '「{cat}」分类暂无游戏',
            hint: '敬请期待，或切换到其他分类看看',
        },
        overseaBlocked: '该游戏无法在中国大陆境内运行',
    },
    en: {
        hero: {
            badge: 'Game Library',
            titleA: 'Game ',
            titleB: 'Showcase',
            subtitle: 'All games in one place — multi-platform, multi-language',
        },
        tabs: { all: 'All Games', recommended: 'Featured' },
        search: {
            placeholder: 'Search by name, tagline, or intro…',
            clear: 'Clear search',
            emptyTitle: 'No games match "{q}"',
            emptyHint: 'Try another keyword, or browse a different category',
        },
        features: { label: 'Features' },
        boards: { recommended: '★ Featured' },
        empty: {
            title: 'No games in "{cat}" yet',
            hint: 'Stay tuned, or browse another category',
        },
        overseaBlocked: 'This game is not available in mainland China',
    },
}
